module.exports = ["ai","2018","2019","2017","fake","cryptocurr","gdpr","blockchain","disinform","ico","ml","opioid","machine-learn","230","blockchain-bas","ai-bas","tensorflow","cosmolog","genealog","microrobot","cav","cra","redempt","learning-bas","btc","dlt","sepsi","fake_news","user_data","protect_regul","general_data","ai_system","ai_technolog","learn_model","reinforc_learn","blockchain_platform"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/words_total.json
// module id = rxqw
// module chunks = 1